import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import API_BASE_URL from '../config/api';
import { useLang } from '../context/LanguageContext';
import '../styles/Footer.css';

const Footer = () => {
  const { nl } = useLang();
  const [services, setServices] = useState([]);
  const [specializations, setSpecializations] = useState([]);
  const [industries, setIndustries] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/services`);
        const data = await response.json();
        if (data.success) {
          setServices(data.data.slice(0, 5));
        }
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };

    const fetchSpecializations = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/specializations`);
        const data = await response.json();
        if (Array.isArray(data)) {
          setSpecializations(data.slice(0, 5));
        } else if (data.success) {
          setSpecializations(data.data.slice(0, 5));
        }
      } catch (error) {
        console.error('Error fetching specializations:', error);
      }
    };

    const fetchIndustries = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/industries`);
        const data = await response.json();
        if (data.success) {
          setIndustries(data.data.slice(0, 5));
        }
      } catch (error) {
        console.error('Error fetching industries:', error);
      }
    };

    fetchServices();
    fetchSpecializations();
    fetchIndustries();
  }, []);

  return (
      <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <img src="/images/Aurelia-tech.png" alt="Aurelia Technology" className="footer-logo" />
          </div>

          <div className="footer-right">
          {/*
          
 hidden as clientt said to hide it 
   <div className="footer-section">
              <h3>{nl ? 'Industrieën' : 'Industries'}</h3>
              <ul>
                {industries.map((industry) => (
                  <li key={industry._id}>
                    <Link to={`/industries/${industry.slug}`}>{(nl && industry.title_nl) || industry.title}</Link>
                  </li>
                ))}
              </ul>
            </div>         
          */


          }

            <div className="footer-section">
              <h3>{nl ? 'Diensten' : 'Services'}</h3>
              <ul>
                {specializations.map((spec) => (
                  <li key={spec._id}>
                    <Link to={`/services#spec-${spec._id}`}>{(nl && spec.title_nl) || spec.title}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-section">
              <h3>{nl ? 'Producten' : 'Products'}</h3>
              <ul>
                {services.map((service) => (
                  <li key={service._id}>
                    <Link to={`/products/${(nl && service.slug_nl) || service.slug}`}>{(nl && service.title_nl) || service.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Aurelia Technology, Inc. {nl ? 'Alle rechten voorbehouden.' : 'All rights reserved.'} | <Link to="/privacy" style={{color: '#999'}}>{nl ? 'Privacybeleid' : 'Privacy'}</Link></p>
        </div>
        </div>
      </footer>
  );
};

export default Footer;
